import { render, staticRenderFns } from "./showMessage.vue?vue&type=template&id=f9a31d72&scoped=true&"
import script from "./showMessage.vue?vue&type=script&lang=js&"
export * from "./showMessage.vue?vue&type=script&lang=js&"
import style0 from "./showMessage.vue?vue&type=style&index=0&id=f9a31d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a31d72",
  null
  
)

export default component.exports